// tslint:disable-next-line: no-submodule-imports
import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useOnClickOutside from 'use-onclickoutside';
import { SET_VOLUME, CHANGE_VOLUME } from '../../actions/Playback';
import { getInstance } from '../../player';
import * as Styles from './VolumeButton.scss';
let timeoutId;
export default function VolumeButton(props) {
    useStyles(Styles);
    const dispatch = useDispatch();
    const { mediaId } = useSelector((state) => state.Media);
    const [volumeLevel, setVolumeLevel] = useState(1);
    const [open, setOpen] = useState(false);
    const volumeButtonContainerRef = useRef(null);
    // Load Orchestra and set the correct volume
    useEffect(() => {
        async function loadPlayer() {
            const player = await getInstance();
            setVolumeLevel(player.getVolume());
        }
        loadPlayer();
    }, []);
    const closeSlider = () => setOpen(false);
    useOnClickOutside(volumeButtonContainerRef, closeSlider);
    const classNames = this.props.isTransportOverlayOpen ? [Styles.transportOverlayOpen, Styles.volumeContainer].join(" ") : Styles.volumeContainer;
    return (React.createElement("div", { className: classNames, ref: volumeButtonContainerRef },
        React.createElement("music-button", { ariaLabelText: "Volume", id: "volume-button", "icon-only": true, onmusicActivate: onTriggerSlider, "icon-name": `volume${volumeLevel > 0 ? 'on' : 'off'}`, variant: "primary", size: props.size || 'small' }),
        open && (React.createElement("div", { className: Styles.slider },
            React.createElement("input", { id: "volume-range", type: "range", onInput: onChange, onChange: onChange, value: volumeLevel, name: "volume", min: "0", max: "1", step: "0.1" })))));
    async function onTriggerSlider() {
        if (open) {
            window.addEventListener('click', (this.sub = (e) => {
                if (!e || !e.target) {
                    return;
                }
                const target = e.target;
                if (open && !target.id.startsWith('volume')) {
                    setOpen(false);
                }
            }));
        }
        else {
            window.removeEventListener('click', this.sub);
        }
        setOpen(!open);
        const player = await getInstance();
        setVolumeLevel(player.getVolume());
    }
    async function onChange(e) {
        const player = await getInstance();
        const eventVolume = +e.target.value;
        setVolumeLevel(eventVolume);
        player.volume(eventVolume);
        dispatch({ type: CHANGE_VOLUME, payload: { mediaId } });
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            dispatch({ type: SET_VOLUME, payload: { volume: eventVolume } });
        }, 1000);
    }
}
